import { render, staticRenderFns } from "./P_matrixInput.vue?vue&type=template&id=815e2b8a&scoped=true"
import script from "./P_matrixInput.vue?vue&type=script&lang=js"
export * from "./P_matrixInput.vue?vue&type=script&lang=js"
import style0 from "./P_matrixInput.vue?vue&type=style&index=0&id=815e2b8a&prod&lang=less"
import style1 from "./P_matrixInput.vue?vue&type=style&index=1&id=815e2b8a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "815e2b8a",
  null
  
)

export default component.exports